import { render, staticRenderFns } from "./ZoomText.vue?vue&type=template&id=f0c2e160&scoped=true&"
import script from "./ZoomText.vue?vue&type=script&lang=js&"
export * from "./ZoomText.vue?vue&type=script&lang=js&"
import style0 from "./ZoomText.vue?vue&type=style&index=0&id=f0c2e160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c2e160",
  null
  
)

export default component.exports